import React from 'react';
import InputWrapper from './InputWrapper';
import { getListeChoix } from './utils';

const CheckedListBoxInput = ({ field, fieldId, value, onChange, label, isRequired, error }) => {
  const checkboxOptions = getListeChoix(field);
  
  if (!checkboxOptions || checkboxOptions.length === 0) {
    return null;
  }
  
  const checkedValues = Array.isArray(value) ? value : [];
  const isCheckboxHorizontal = field.affichageHorizontal === true;
  
  return (
    <InputWrapper field={field} label={label} isRequired={isRequired} error={error}>
      <div className={isCheckboxHorizontal ? 'form-checkbox-group-horizontal' : ''}>
        {checkboxOptions.map((option, index) => {
          const optionValue = option.value || option;
          const isChecked = checkedValues.includes(optionValue);
          return (
            <div key={index} className="form-option-item">
              <input
                type="checkbox"
                id={`${fieldId}_${index}`}
                checked={isChecked}
                onChange={e => {
                  const newValues = e.target.checked
                    ? [...checkedValues, optionValue]
                    : checkedValues.filter(v => v !== optionValue);
                  onChange(fieldId, newValues);
                }}
                disabled={field.readOnly || false}
              />
              <label htmlFor={`${fieldId}_${index}`} className="form-option-label">
                {option.label || option}
              </label>
            </div>
          );
        })}
      </div>
    </InputWrapper>
  );
};

export default CheckedListBoxInput;

